module.exports = __webpack_public_path__ + "static/media/Swis721_Cn_BT_Bold.2e0efaf5.woff2";